import { useEffect, useRef } from 'react';

import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import smoothscroll from 'smoothscroll-polyfill';
import Seo from 'src/components/atoms/seo';
import APACSection from 'src/components/organisms/b2bLandingPage/apacSection';
import ContentSection from 'src/components/organisms/b2bLandingPage/contentSection';
import Footer from 'src/components/organisms/b2bLandingPage/footer';
import Header from 'src/components/organisms/b2bLandingPage/header';
import IntroductionSection from 'src/components/organisms/b2bLandingPage/introductionSection';
import OurServiceSection from 'src/components/organisms/b2bLandingPage/ourServiceSection';
import SimpleStepSection from 'src/components/organisms/b2bLandingPage/simpleStepSection';
import TestimonialSection from 'src/components/organisms/b2bLandingPage/testimonialSection';
import WhyChooseUsSection from 'src/components/organisms/b2bLandingPage/whyChooseUsSection';
import config from 'src/config';

import BusinessStyle from './style';

import { useInsider } from '@hooks/dataTracking/useInsider';

const BusinessPage = () => {
  const { t } = useTranslation('business');
  const contactUsFormRef = useRef<any>();

  useInsider({
    autoLoad: true,
  });

  const onClickContactUs = () => {
    if (contactUsFormRef.current) {
      contactUsFormRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    smoothscroll.polyfill();

    window.onbeforeunload = () => {
      window.scrollTo(0, 0);
    };
  }, []);

  return (
    <BusinessStyle>
      <Seo
        title={t('seo_title')}
        description={t('seo_description')}
        image_url={`${config.IMAGE_CDN_HOST}/assets/b2b-landing/share-logo.jpg`}
      />
      <Header onClickContactUs={onClickContactUs} />
      <IntroductionSection />
      <WhyChooseUsSection />
      <OurServiceSection />
      <ContentSection />
      <TestimonialSection />
      <SimpleStepSection />
      <APACSection />
      <Footer contactUsFormRef={contactUsFormRef} />
    </BusinessStyle>
  );
};

type Params = {
  locale: string;
};

export const getStaticProps = async ({ locale }: Params) => ({
  props: {
    ...(await serverSideTranslations(locale, ['business', 'common'])),
  },
});

export default BusinessPage;
